import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCarussel: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="carussel, slides"><path d="M17.5 5.75H21.25V18.25H17.5M6.5 18.25H2.75V5.75H6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.5 3.75H6.5V20.25H17.5V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCarussel;
